import {
  ACTIVATING_GOOGLE_ANALYTICS_REQUEST, ACTIVATING_GOOGLE_ANALYTICS_SUCCEDDED, ACTIVATING_GOOGLE_ANALYTICS_FAILED,
  UPDATING_GOOGLE_ANALYTICS_REQUEST, UPDATING_GOOGLE_ANALYTICS_SUCCEDDED, UPDATING_GOOGLE_ANALYTICS_FAILED,
} from '../../actions/actionTypes.jsx';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  activation: {
    activating: false,
    error: null
  },
};

function googleAnalyticsReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIVATING_GOOGLE_ANALYTICS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: true,
          error: null
        }
      })
    case ACTIVATING_GOOGLE_ANALYTICS_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: false,
          error: null
        }
      })
    case ACTIVATING_GOOGLE_ANALYTICS_FAILED:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: false,
          error: action.payload
        }
      })

    case UPDATING_GOOGLE_ANALYTICS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_GOOGLE_ANALYTICS_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_GOOGLE_ANALYTICS_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })  
    default:
      return state
  }
}

export { googleAnalyticsReducer };